// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dt-3";
export var flatBottomCorners = "_dt-5";
export var productImage = "_dt-0";
export var quantityContainer = "_dt-2";
export var quantityHeader = "_dt-6";
export var tooltip = "_dt-1";
export var wrapAndEllipsesOverflow = "_dt-4";